module.exports = __webpack_public_path__ + "img/img-headerImg.c1b5b70a.png";